<ng-container *ngIf="{ show: fieldAddonTemplates?.length > 0, templates: fieldAddonTemplates } as fieldAddons">
    <div *ngIf="fieldAddons.show" slot="end" class="slotEnd addon" (mouseover)="hover.emit('none')" (mouseleave)="hover.emit(null)">
        <div class="fieldAddon">
            <ng-container *ngFor="let template of fieldAddons.templates">
                <ng-container *ngTemplateOutlet="template, context: { $implicit: field }"></ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>
<div slot="end" class="slotEnd">
    <mat-icon class="material-icons required"
              color="{{(control?.statusChanges | async) === 'INVALID' ? 'warn' : 'grey'}}"
              *ngIf="field.required || (control?.statusChanges | async) === 'INVALID'">
        priority_high</mat-icon>
</div>
